import QuickActionBlock from "./quickActionBlock";
import IconCode from "@/src/lib/iconCode";

const QuickAction = () => {
    return (
        <div className="md:py-8 py-3 mt-4 px-6 md:px-0 max-w-6xl mx-auto">
            <h2 className="md:text-2xl text-xl text-black font-bold md:mb-6 mb-5 md:text-left text-center">
                Quick Actions
            </h2>
            <div className="grid md:gap-6 sm:gap-3 gap-2 md:grid-cols-4 sm:grid-cols-2 grid-cols-1">
                <QuickActionBlock
                    title="Download Report"
                    icon={IconCode.download}
                    link="/my-account/my-orders"
                />
                <QuickActionBlock
                    title="Track Orders"
                    icon={IconCode.order}
                    link="/my-account/my-orders"
                />
                <QuickActionBlock
                    title="Health Graph"
                    icon={IconCode.healthGraph}
                    link="/my-account/health-graph"
                />
                <QuickActionBlock
                    title="Manage Family"
                    icon={IconCode.team}
                    link="/my-account/members"
                />
            </div>
        </div>
    );
};

export default QuickAction;
